import React, { useEffect, useRef } from 'react';
import { AiOutlineMenu } from 'react-icons/ai';
import { FiShoppingCart } from 'react-icons/fi';
import { BsChatLeft } from 'react-icons/bs';
import { RiNotification3Line } from 'react-icons/ri';
import { MdKeyboardArrowDown } from 'react-icons/md';
import { TooltipComponent } from '@syncfusion/ej2-react-popups';
import user from '../data/user.png';
import { Cart, Chat, Notification, UserProfile } from '.';
import { useDispatch, useSelector } from 'react-redux';
import { setActiveMenu, toggleClick } from '../redux-store/slices/appSlice'

const NavButton = ({ title, customFunc, icon, color, dotColor }) => (
  <TooltipComponent content={title} position="BottomCenter" cssClass="my-tooltip">
    <button
      type="button"
      onClick={customFunc}
      style={{ color }}
      className="relative text-xl rounded-full p-3 hover:bg-light-gray"
    >
      {dotColor && (
        <span
          style={{ background: dotColor }}
          className="absolute inline-flex rounded-full h-2 w-2 top-2 right-2"
        />
      )}
      {icon}
    </button>
  </TooltipComponent>
);

const Navbar = ({ activeMenu, setActiveMenu, currentColor, handleClick, isClicked, currentMode}) => {
  //const dispatch = useDispatch();
  //const { currentColor, activeMenu, isClicked } = useSelector((state) => state.appSlice);

  const handleActiveMenu = () => {
    setActiveMenu(!activeMenu)
  };

  return (
    <div className="flex justify-between p-2 md:mr-6 md-ml-6 relative">
      <NavButton customFunc={handleActiveMenu} title="Menu" icon={<AiOutlineMenu />} color={currentColor} />
      <div className="flex">
        <NavButton title="Cart" customFunc={() => handleClick('cart')} color={currentColor} icon={<FiShoppingCart />} />
        <NavButton title="Chat" dotColor="#03C9D7" customFunc={() => handleClick('chat')} color={currentColor} icon={<BsChatLeft />} />
        <NavButton title="Notification" dotColor="rgb(254, 201, 15)" customFunc={() => handleClick('notification')} color={currentColor} icon={<RiNotification3Line />} />
        
        <TooltipComponent content="Profile" position="BottomCenter">
          <div  
            className="flex items-center gap-2 cursor-pointer px-2 py-1 hover:bg-light-gray rounded-lg"
            onClick={() => handleClick('userProfile')}
          >
            <img className="rounded-full w-8 h-8" src={user} alt="user-profile" />
            <p>
              <span className="text-gray-400 text-14">Hi,</span>
              <span className="text-gray-400 text-14 ml-1 font-bold">Admin</span>
              <MdKeyboardArrowDown className="text-gray-400 text-14" />
            </p>
          </div>
        </TooltipComponent>

        {/* {isClicked?.notification && <Notification />}
        {isClicked?.chat && <Chat />}
        {isClicked?.cart && <Cart />}
        {isClicked?.userProfile && <UserProfile />} */}
      </div>
    </div>
  );
};

export default Navbar;
